module.exports = __webpack_public_path__ + "static/media/wave-avatar.0d58b615.svg";